import {Coupon_HighTierCoupon_ProductsInformation} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  ProductImage,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';

export const ProductsInformation: FC<{
  productsInformation: Coupon_HighTierCoupon_ProductsInformation;
}> = ({productsInformation}) => {
  const {productImages, label} = productsInformation;
  return (
    <Wrapper
      data-testid="productsInformation"
      $noProductImages={productImages.length === 0}
    >
      {productImages.length > 0 && (
        <Products>
          {productImages.map(productImage => (
            <StyledProductImage
              key={productImage.src}
              src={productImage.src}
              alt={productImage.description}
              widths={[120, 240, 360]}
              ratio="1:1"
            />
          ))}
        </Products>
      )}
      <Label>{label}</Label>
    </Wrapper>
  );
};

const Wrapper = styled.div<{$noProductImages?: boolean}>`
  padding-block: 6px;
  display: flex;
  gap: 5px;
  align-items: center;
  min-height: 44px;
  width: 100%;
  justify-content: ${({$noProductImages}) =>
    $noProductImages ? 'flex-start' : 'flex-end'};
`;

const Products = styled.div`
  display: flex;
  flex: 1;
  gap: 4px;
`;

const StyledProductImage = styled(ProductImage)`
  border-radius: 2px;
  height: 32px;
  width: 32px;
  padding-top: 0;

  img {
    padding: 10%;
    object-fit: contain;
    object-position: center;
  }
`;

const Label = styled.div`
  background: ${COLORS.PrimaryCoupon};
  border-radius: 40px;
  padding: 2px 8px;
  overflow: hidden;
  color: ${COLORS.White};
  text-overflow: ellipsis;
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: 1.6;
  height: fit-content;
  text-align: center;
`;
